import {
	EVENT_ACTION_PARKING_PRODUCTS_ADDED_UPGRADE,
	EVENT_ACTION_PARKING_PRODUCTS_REMOVED_UPGRADE,
	EVENT_CATEGORY_PARKING_PRODUCTS,
	trackCustomEvent,
} from '../../../../../../shared/analytics';
import { IParkingProductUpgrade } from '../../../../../domain/parking-product/models/IParkingProductUpgrade';

export function trackToggleUpgrade(
	upgrade: IParkingProductUpgrade,
	isChecked: boolean,
) {
	if (isChecked) {
		trackCustomEvent({
			category: EVENT_CATEGORY_PARKING_PRODUCTS,
			action: EVENT_ACTION_PARKING_PRODUCTS_ADDED_UPGRADE,
			label: upgrade.name,
			value: upgrade.id,
		});
	} else {
		trackCustomEvent({
			category: EVENT_CATEGORY_PARKING_PRODUCTS,
			action: EVENT_ACTION_PARKING_PRODUCTS_REMOVED_UPGRADE,
			label: upgrade.name,
			value: upgrade.id,
		});
	}
}
